import DashBoardTalents from './DashBoardTalents';

export default DashBoardTalents;
